import { Injectable, Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import {Subscription} from 'rxjs';

import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';
import { GlobalEventMangerService } from '../global-event-manger.service';
import { Helper } from '../helpers/helper';

@Component({
  selector: 'echexpayment-freetrialtoactive',
  templateUrl: './freetrialtoactive.component.html',
  styleUrls: ['./activefreetrial.component.css'],
  providers: [Modal]
})
export class FreetrialtoactiveComponent implements OnInit {
	public freetrial: any = {};
	public signupPlanList: any = {};
	public token: string;
	public _id: string;
	public planName: string;
	public stripe_plan: string;
	public stripe_id: string;
	busy: Subscription;
  
	constructor(private userService: UserService, private toastr: ToastrService, private router: Router, vcRef: ViewContainerRef, public modal: Modal, private globalEventMangerService: GlobalEventMangerService, private localStorageService: LocalstorageService) { 
	
		var currentUser = this.localStorageService.getData("currentUserToken");;
        this.token =  currentUser.token;
	    let userDetails = this.localStorageService.getData("currentUser");
        this._id = userDetails._id;
		
		this.planName = userDetails.subscriptions[0].plan;
        this.stripe_plan = userDetails.subscriptions[0].stripe_plan;
        this.stripe_id = userDetails.subscriptions[0].stripe_id;
	
	}

	ngOnInit() {
		
	}
	// Free trial to active
	freeTrialToActive() {
		var data = {
		  _id :this._id,
		  token:this.token,
		  plan :this.planName,
		  stripe_plan :this.stripe_plan,
		  stripe_id :this.stripe_id,
		}
		let responseData = <any>{};
		this.busy = this.userService.freeTrialToActivate(data).subscribe(
		   response => {
		   responseData = response;
		   this.toastr.success(responseData.message, 'Success!');
			  if(responseData.message){
			  setTimeout (() => {
				 this.modal.confirm()
					.size('sm')
					.title('CasherPay')
					.body(`Successfully Activated your account, Please logout and login again, click on 'Yes' to logout.`)
					.okBtn('Yes')
					.okBtnClass('btn btn-success')
					.cancelBtnClass('btn btn-warning')
				   .open()
					.then( (resultPromise) => {
						resultPromise.result.then( (result) => {
						this.localStorageService.removeData('currentUser');
						this.globalEventMangerService.showNavBar(false);
						this.router.navigate(['/login']);
					  }, 
					  () => {
					   console.log('Cancel');
					  } );
				  });
			  },
			  600)   
			  }
		   },
		   error => {
				responseData = error;
				this.toastr.error(responseData.error.message, 'Failed!');
		   
		   }
		);
	}
	// Go to login
	gotoLogin(){
		this.localStorageService.removeData('currentUser');
		this.globalEventMangerService.showNavBar(false);
		this.router.navigate(['/login']);
	}

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/activefreetrial/freetrialtoactive.component.ts